import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
  FacebookMessengerShareButton,
  LinkedinShareButton,
} from 'react-share'

import { ShareButtonsLayout } from '../styles/PageLayout'
import { ParagraphL } from '../styles/Typography'

import SocialMsg from './icons/socialMsg'
import SocialFb from './icons/socialFb'
import SocialTw from './icons/socialTw'
import SocialIn from './icons/socialIn'
import SocialMail from './icons/socialMail'

/**
 * A list of Share Buttons to be used in Project Details pages.
 * @param {ComponentProps} props
 * @param {boolean} props.isColumn
 * @returns {StatelessComponent}
 */
const ShareButtons = ({ isColumn }) => {
  const [shareUrl, setShareUrl] = useState()

  useEffect(() => {
    setShareUrl(window.location.href)
  })

  return (
    <ShareButtonsLayout column={isColumn}>
      <ParagraphL>share</ParagraphL>
      <FacebookMessengerShareButton url={shareUrl}>
        <SocialMsg />
      </FacebookMessengerShareButton>
      <FacebookShareButton url={shareUrl}>
        <SocialFb />
      </FacebookShareButton>
      <TwitterShareButton url={shareUrl}>
        <SocialTw />
      </TwitterShareButton>
      <LinkedinShareButton url={shareUrl}>
        <SocialIn />
      </LinkedinShareButton>
      <EmailShareButton url={shareUrl}>
        <SocialMail />
      </EmailShareButton>
    </ShareButtonsLayout>
  )
}

ShareButtons.propTypes = {
  isColumn: PropTypes.bool,
}

ShareButtons.defaultProps = {
  isColumn: undefined,
}

export default ShareButtons
